import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllContractors from "./AllAgencyContractors";
import { useProfile } from "Components/Hooks/UserHooks";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const AgencyContractors = () => {
  const location = useLocation();
  const { userProfile } = useProfile();
  usePageActivity(location.pathname, "Agency Contractors");

  document.title = "Contractors | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title={`${userProfile?.agency?.name} Contractors`}
            pageTitles={[
              { title: "Dashboard", link: "/agency-dashboard/agency" },
            ]}
          />

          <AllContractors />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AgencyContractors;
